import { DeleteTwoTone, EditTwoTone, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Popconfirm, Row, Space, Table, Typography } from "antd";

const { Text } = Typography;

const iconStyle = { fontSize: 16 };

const StyleItemCard = ({
  style,
  viewMode,
  onEditStyle,
  onDeleteStyle,
  onAddItem,
  onEditItem,
  onDeleteItem,
}) => {
  const itemColumns = [
    {
      title: "Item Category",
      dataIndex: "item_category_name",
      key: "item_category_name",
    },
    { title: "Item", dataIndex: "item_name", key: "item_name", width: 200 },
    { title: "Color", dataIndex: "color_name", key: "color_name" },
    { title: "Sub Style", dataIndex: "sub_style_no", key: "sub_style_no" },
    { title: "Unit", dataIndex: "unit_name", key: "unit_name" },
    { title: "Qty", dataIndex: "order_qty", key: "order_qty" },
    { title: "YY", dataIndex: "yy", key: "yy" },
    { title: "Roll Qty", dataIndex: "roll_qty", key: "roll_qty" },
    {
      title: "Conv. Unit",
      dataIndex: "convertion_unit_name",
      key: "convertion_unit_name",
    },
    { title: "Conversion Qty", dataIndex: "qty", key: "qty" },
    ...(!viewMode
      ? [
          {
            title: "Action",
            key: "action",
            width: 110,
            fixed: "right",
            render: (_, record) => (
              <Space size={4}>
                <Button
                  type="text"
                  size="middle"
                  icon={<EditTwoTone style={iconStyle} />}
                  onClick={() => onEditItem(style.key, record)}
                />
                <Popconfirm
                  title="Delete this item?"
                  onConfirm={() => onDeleteItem(style.key, record.key)}
                >
                  <Button
                    type="text"
                    size="middle"
                    danger
                    icon={<DeleteTwoTone style={iconStyle} />}
                  />
                </Popconfirm>
              </Space>
            ),
          },
        ]
      : []),
  ];

  return (
    <Card
      size="small"
      style={{ marginTop: 16 }}
      title={<Text strong>{style.style_no}</Text>}
      extra={
        !viewMode && (
          <Space size={4}>
            <Button
              type="text"
              size="middle"
              icon={<EditTwoTone style={iconStyle} />}
              onClick={() => onEditStyle(style)}
            />
            <Popconfirm
              title="Delete this style and all its items?"
              onConfirm={() => onDeleteStyle(style.key)}
            >
              <Button
                type="text"
                size="middle"
                danger
                icon={<DeleteTwoTone style={iconStyle} />}
              />
            </Popconfirm>
          </Space>
        )
      }
    >
      <Row gutter={[16, 8]} style={{ marginBottom: 12 }}>
        <Col span={6}>
          <Text type="secondary">Sales Contract: </Text>
          <Text>{style.sales_contract_no || "-"}</Text>
        </Col>
        <Col span={6}>
          <Text type="secondary">Buying Office: </Text>
          <Text>{style.buying_office_name || "-"}</Text>
        </Col>
        <Col span={6}>
          <Text type="secondary">PO: </Text>
          <Text>{style.original_po || "-"}</Text>
        </Col>
      </Row>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <Text strong>Items</Text>
        {!viewMode && (
          <Button
            type="primary"
            size="small"
            icon={<PlusOutlined />}
            onClick={() => onAddItem(style.key)}
          >
            Add Item
          </Button>
        )}
      </div>

      <Table
        size="small"
        columns={itemColumns}
        dataSource={style.items || []}
        rowKey="key"
        pagination={false}
        scroll={{ x: true }}
        locale={{ emptyText: "No items added yet" }}
      />
    </Card>
  );
};

export default StyleItemCard;
